import React from "react";
import { formatRelative } from 'date-fns';
import { getAuth } from "firebase/auth";

const Message = ({
    createdAt = null,
    text = '',
    displayName = '',
    photoURL = '',
    uid = '',
}) => {

    const userId = getAuth().currentUser.uid



    return (
        <div className={userId === uid ? "py-3 flex flex-row-reverse items-start" : "py-3 flex items-start"}>
            <div className={userId === uid ? "flex items-center flex-row-reverse rounded-lg px-4 py-2 bg-neutral-200 dark:bg-gray-700 shadow-lg" : "flex items-center rounded-lg px-4 py-2 bg-neutral-200 dark:bg-gray-700 shadow-lg"}>
                {photoURL ? (
                    <img
                        src={photoURL}
                        alt="Avatar"
                        className={uid === userId ? "rounded-full ml-4 w-9 h-9 sm:w-12 sm:h-12" : "rounded-full mr-4 w-9 h-9 sm:w-12 sm:h-12"}
                    />
                ) :
                    <div className="relative w-10 h-10 overflow-hidden bg-gray-100 rounded-full dark:bg-gray-600">
                        <svg className="absolute w-12 h-12 text-gray-400 -left-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd"></path></svg>
                    </div>}
                <div>
                    <div className="flex items-center mb-1">
                        {displayName ? (
                            <p className="mr-2 text-primary-500 text-gray-700 dark:text-gray-400 font-bold text-xs sm:text-base">{displayName}</p>
                        ) : null}
                        {createdAt?.seconds ? (
                            <span className="text-gray-500 text-xs">
                                {formatRelative(new Date(createdAt.seconds * 1000), new Date())}
                            </span>
                        ) : null}
                    </div>
                    <p className="text-gray-700 dark:text-gray-400 text-xs sm:text-base">{text}</p>
                </div>
            </div>
        </div>

    )
}

export default Message;